import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Container, Dimmer, Header, Loader } from "semantic-ui-react";
import { Navigation } from "src/components/Navigation";
import { withAuthorization } from "../../components/Session/withAuthorization";
const DashboardsTable = React.lazy(
  () => import(/* webpackChunkName: "DashboardsTable" */ "./DashboardsTable")
);
const DashboardsComponent = ({
  authUser,
  orgId,
  history,
  match,
  location,
  usersStatus,
}: any) => (
  <React.Fragment>
    <Navigation />
    <Container className="main-container">
      <Header as="h2" className="page-title">
        Dashboards
      </Header>
      <React.Suspense
        fallback={
          <Dimmer inverted={true}>
            <Loader size="small">Fetching data</Loader>
          </Dimmer>
        }
      >
        <DashboardsTable
          orgId={orgId}
          authUser={authUser}
          history={history}
          location={location}
          usersStatus={usersStatus}
        />
      </React.Suspense>
    </Container>
  </React.Fragment>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
  usersStatus: state.sessionState.usersStatus,
});

const authCondition = (authUser: any) => !!authUser;

const Dashboards = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(DashboardsComponent));

export default Dashboards;



// WEBPACK FOOTER //
// ./src/containers/Dashboards/index.tsx